// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"952eb03c","914":"fe20bf2e"}[chunkId] + ".chunk.css";
};